module.exports = {
      id: "search-map-usage",
      viewBox: "0 0 16 14",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#search-map-usage",
      toString: function () {
        return this.url;
      }
    }